






































import Vue from "vue"
import SimpleModal from "~/components/guideline/modal/SimpleModal.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"
import MaterialIcon, {
  OUTLINED,
} from "~/components/guideline/icon/MaterialIcon.vue"

export default Vue.extend({
  components: {
    SimpleModal,
    ConversionButton,
    MaterialIcon,
  },
  props: {
    isShown: {
      type: Boolean,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
    buttonLabel: {
      type: String,
      required: true,
    },
  },
  computed: {
    iconType() {
      return { OUTLINED }
    },
  },
  methods: {
    handleClose() {
      this.$emit("close")
    },
    handleClick() {
      this.$emit("click")
    },
  },
})
